var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-auto w-1/3 mt-64"},[_c('LanguageForm',{attrs:{"model":_vm.model,"endpoint":"/api/1.0/language/create","title":"Create Language","label":"Create Language"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }